import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../provider/authContextType';

const fetchMedicalCondition = async (
  memberId: string,
  identityDocument: string,
  identityDocumentTypeId: string,
  origin: string | null
) => {
  const response = await axios.get(
    `${origin}/affiliation/getmedicalconditionbymemberId`,
    {
      params: {
        memberId: memberId,
        identityDocument: identityDocument,
        identityDocumentTypeId: identityDocumentTypeId,
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer `,
      },
    }
  );
  return response.data;
};

export const useFetchMedicalCondition = (payload: any) => {
  const { origin } = useAuth();
  return useQuery({
    queryKey: ['medicalCondition', payload.memberCode],
    queryFn: () => {
      return fetchMedicalCondition(
        payload.memberCode,
        payload.identityDocument,
        payload.identityDocumentTypeId,
        origin
      );
    },
  });
};
